(() => {
  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

  const videoMarkup = (url, title) => {
    const source = String(url || '').trim();
    const lower = source.toLowerCase().split('?')[0];

    try {
      const parsed = new URL(source, window.location.origin);
      const host = parsed.hostname.replace(/^www\./, '');

      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const id = parsed.searchParams.get('v') || parsed.pathname.split('/embed/')[1];
        if (id) {
          return `<iframe src="https://www.youtube.com/embed/${escapeHtml(id)}?autoplay=1&rel=0" title="${escapeHtml(title)}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
        }
      }

      if (host === 'youtu.be') {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        if (id) {
          return `<iframe src="https://www.youtube.com/embed/${escapeHtml(id)}?autoplay=1&rel=0" title="${escapeHtml(title)}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
        }
      }

      if (host === 'vimeo.com') {
        const id = parsed.pathname.split('/').filter(Boolean).pop();
        if (id) {
          return `<iframe src="https://player.vimeo.com/video/${escapeHtml(id)}?autoplay=1" title="${escapeHtml(title)}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        }
      }
    } catch (error) {
      return '';
    }

    if (lower.endsWith('.mp4')) {
      return `<video controls autoplay playsinline><source src="${escapeHtml(source)}" type="video/mp4"></video>`;
    }

    return `<a class="link-uline" href="${escapeHtml(source)}" target="_blank" rel="noopener">Open video</a>`;
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.peyk-journal__filter-input');
    if (!input) return;
    const journal = input.closest('.peyk-journal');
    if (journal) journal.dataset.filter = input.value;
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-peyk-lightbox]');
    const dialog = document.querySelector('[data-peyk-lightbox-dialog]');
    if (!trigger || !dialog) return;

    event.preventDefault();
    const content = dialog.querySelector('[data-peyk-lightbox-content]');
    const caption = dialog.querySelector('[data-peyk-lightbox-caption]');
    const type = trigger.dataset.lightboxType;
    const src = trigger.dataset.lightboxSrc;
    const srcset = trigger.dataset.lightboxSrcset;
    const sizes = trigger.dataset.lightboxSizes;
    const alt = trigger.dataset.lightboxAlt || '';
    const imageAttrs = srcset
      ? ` srcset="${escapeHtml(srcset)}" sizes="${escapeHtml(sizes || '100vw')}"`
      : '';

    dialog.returnFocusTo = trigger;
    content.innerHTML = type === 'video'
      ? videoMarkup(src, alt)
      : `<img src="${escapeHtml(src)}"${imageAttrs} alt="${escapeHtml(alt)}" loading="eager">`;
    caption.textContent = trigger.dataset.lightboxCaption || '';

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-peyk-lightbox-dialog]');
    if (!dialog) return;
    if (event.target.matches('[data-peyk-lightbox-close]') || event.target === dialog) {
      dialog.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-peyk-lightbox-dialog][open]').forEach((dialog) => dialog.close());
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches('[data-peyk-lightbox-dialog]')) return;
    dialog.querySelector('[data-peyk-lightbox-content]').innerHTML = '';
    dialog.querySelector('[data-peyk-lightbox-caption]').textContent = '';
    dialog.returnFocusTo?.focus?.();
  }, true);
})();
